import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { BraintreePayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { DISPATCH_ACTION } from '@whitbread-eos/api';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import Error from '../../assets/icons/Error';
import Notification from '../Notification';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function PaypalWBButton(_ref) {
  var currency = _ref.currency,
    onApprove = _ref.onApprove,
    onError = _ref.onError,
    createBillingAgreement = _ref.createBillingAgreement,
    style = _ref.style;
  var _usePayPalScriptReduc = usePayPalScriptReducer(),
    _usePayPalScriptReduc2 = _slicedToArray(_usePayPalScriptReduc, 2),
    _usePayPalScriptReduc3 = _usePayPalScriptReduc2[0],
    options = _usePayPalScriptReduc3.options,
    isRejected = _usePayPalScriptReduc3.isRejected,
    isPending = _usePayPalScriptReduc3.isPending,
    dispatch = _usePayPalScriptReduc2[1];
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  useEffect(() => {
    dispatch({
      type: DISPATCH_ACTION.RESET_OPTIONS,
      value: _objectSpread(_objectSpread({}, options), {}, {
        currency: currency
      })
    });
  }, [currency]);
  return _jsx(_Fragment, {
    children: isRejected && !isPending ? _jsx(Box, {
      mt: "sm",
      mb: "5xl",
      children: _jsx(Notification, {
        variant: "error",
        status: "error",
        description: t('booking.payment.paypal.loading.error'),
        svg: _jsx(Error, {}),
        wrapperStyles: {
          mb: '-2xl',
          mt: '2xl'
        }
      })
    }, "payment_custom_message") : _jsx(Box, _objectSpread(_objectSpread({}, buttonStyle), {}, {
      children: _jsx(BraintreePayPalButtons, {
        style: _objectSpread({}, style),
        disabled: false,
        fundingSource: "paypal",
        forceReRender: [currency],
        createBillingAgreement: createBillingAgreement,
        onApprove: onApprove,
        onError: onError
      })
    }))
  });
}
export default PaypalWBButton;
var buttonStyle = {
  mt: 'lg',
  w: {
    mobile: 'full',
    lg: '18rem',
    xl: '19.3125rem'
  }
};